import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";

import { registerNavSection } from "./shell/navigation";

registerNavSection({ key: "workforce", spoke: "workforce", title: "Workforce", icon: GroupsOutlinedIcon, order: 57, entries: [
  { label: "Time clock & overview", to: "/app/workforce", permission: "workforce.time.view" },
  { label: "My time", to: "/app/workforce/me" },
  { label: "Time & approvals", to: "/app/workforce/time", permission: "workforce.time.view" },
  { label: "Employees", to: "/app/workforce/employees", permission: "workforce.employee.view" },
  { label: "Training requirements", to: "/app/masterdata/training-requirements", permission: "workforce.employee.view" },
  { label: "Labor rates", to: "/app/masterdata/labor-rates", permission: "workforce.employee.view" },
] });
